import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  OnInit
} from '@angular/core';
import { AberrationsActionCreatorService } from '@ispm/dashboard/aberrations/services/aberrations-action-creator.service';
import { AberrationsService } from '@ispm/dashboard/aberrations/services/aberrations.service';
import { AberrationInfoService } from '@ispm/dashboard/test/components/aberration-info-service/aberration-info.service';
import { DiagnosticOrderActionsService } from '@ispm/dashboard/test/services/diagnostic-order-actions.service';
import { PollJobService } from '@ispm/dashboard/test/services/poll-job.service';
import { ConfirmModalComponent } from '@ispm/layout/components/modals/confirm-modal/confirm-modal.component';
import { ModalTypes } from '@ispm/layout/components/modals/contants/modal-types.enum';
import { PlaceholderModalComponent } from '@ispm/layout/components/modals/placeholder-modal/placeholder-modal.component';
import { ReassignTestModalComponent } from '@ispm/layout/components/modals/reassign-test-modal/reassign-test-modal.component';
import { DynamicModalLoaderService } from '@ispm/layout/services/dynamic-modal-loader.service';
import { UserActionCreatorService } from '@ispm/user/services/user-action-creator.service';
import { UserService } from '@ispm/user/services/user.service';
import { WorkflowConfigService } from '@ispm/workflow/services/workflow-config.service';
import { FilterActionCreatorService } from '../../../filter/services/filter-action-creator.service';
import { FilterService } from '../../../filter/services/filter.service';
import _, { cloneDeep } from 'lodash';
import { Observable } from 'rxjs';
import { AberrationExtraModalComponent } from './aberration-extra-modal/aberration-extra-modal.component';
import { AberrationService } from '@ispm/migration/services/aberration.service';
import { PractitionerService } from '@ispm/migration/services/practitioner.service';
import { TestService } from '@ispm/dashboard/test/services/test.service';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import { WorkflowService } from '@ispm/workflow/services/workflow.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import { activeTabObject } from "@ispm/test/constants/Tabs.constants";
import { ActivatedRoute, Router } from "@angular/router";
import {
  ReleaseInterpretationComponent
} from "@ispm/migration/components/aberrations/release-interpretation/release-interpretation.component";
import { RouterManagerService } from "@ispm/core/services/router-manager.service";
import { WorklistNavigationService } from '@ispm/dashboard/test/services/worklist-navigation.service';
import { CoreActionCreatorService } from '@ispm/core/services/core-action-creator.service';
import { IWorkflow } from '@ispm/core/interfaces/workflow.interface';

@Component({
  selector: 'gen-aberrations',
  templateUrl: './aberrations.component.html',
  styleUrls: ['./aberrations.component.scss'],
  host: { style: 'height: 100%' },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AberrationsComponent implements OnInit, OnDestroy, AfterViewInit {

  readonly ABERRATION_OBJECT_NAME = 'aberration';
  readonly DEFAULT_INITIAL_REPORT = 'initial report';
  readonly DEFAULT_PROCEED_WITH_SELECTED_ABERRATIONS = 'Proceed with selected aberrations';
  readonly DEFAULT_RELEASE_REPORT_TITLE = 'Release initial report';
  readonly PROCEED_WITH_SELECTED_ABERRATIONS_TITLE = 'Proceed';
  readonly GENOMICS_ABERRATIONS_SELECTED= 'Genomic aberrations selected';

  private igvConfig: any;
  public aberrationsCtrl: any;
  public immunotherapyEditAllowed: any;
  public searchLoading: any;
  private resourcesMap: any = {};
  private subscribers: Array<any> = [];
  private isSorting: any;
  public filteredMessage: any;
  private tableSortBy = { };
  private onLoad = false;
  public secondOpinionForm: any;
  private loadFiltersRequests = [];
  private defaultModalityAndData: any;
  public selectedModality: any;
  public selectedModalityType: any;
  public testTableData: any;
  private pathologistInfoId: any;
  public notesConfig = {
    snv: {
      main: { title: 'HGNC_gene', subtitle: 'Canonical_HGVS_Protein'},
      fallback: { title: 'coordinate'}
    },
    fusions: {
      main: { title: 'GeneName1', subtitle: 'GeneName2'},
      fallback: { title: 'GeneName1'}
    },
    cnv: {
      main: { title: 'Gene', subtitle: 'AberrationType'},
      fallback: { title: 'Gene'}
    },
    wildtype: {
      main: { title: 'gene'},
      fallback: { title: 'gene'}
    }
  };
  private testConfigSubscriber: any;
  public resourcesConfigs = { };
  public testTypeId: string = '';
  public showIgv = false;
  private loaderSubscriber: any;
  public dataIsLoading = true;
  private aberrationDataSubscriber: any;
  public modalitiesNames = {
    snv: 'snv',
    cnv: 'cnv',
    wildtype: 'wildtype',
    immunotherapy: 'immunotherapy'
  };
  public highlighted = [];
  public results = [];
  private aberrationUpdateSubscriber: any;
  private isFirstLoad = true;
  public modalitiesWithResult = new Set();
  private alreadySubscribed: boolean;
  private appliedFilterPropertiesSubscriber: any;
  public appliedFilters: any = [];
  public currentRevision: any;
  private currTest: any;
  public isSecondOpinion: any;
  public currentModality: any;
  public testConfiguration: any;
  private currentPatientAnalysis: any;
  public isToshowFiltersRefineMsg: any;
  public isTestFailed: boolean;
  public clickedOnProceedWithSelectedAberrations = false;
  public send2NdOpinionDialogIsOpen = false;
  public performer: any;
  public releaseInitialReportDialogIsOpen = false;
  public activeJobName: any;
  public secondOpinioner: any;
  private providers: any;
  public statusIsAfterInitialResults: any;
  public stateParams: any;
  public loadModalityContent : boolean = false;
  private patient: any;
  public collapsed = { };
  public aberrationFilter: any = { };
  public isFilterPanelClose: boolean = false;
  private autoScrollToTop: boolean = false;
  private transformedValue: string;

  /* scroll variable */
  private buffer = 5;
  public startIndex = 0;
  public endIndex = 39;
  private onScroll: () => void = undefined;

  constructor(
    private aberrationService: AberrationService,
    private testService: TestService,
    private activatedRoute: ActivatedRoute,
    private coreActionCreatorService: CoreActionCreatorService,
    private router: Router,
    private workflowService: WorkflowService,
    private authService: AuthenticationService,
    private userActionCreatorService: UserActionCreatorService,
    private workflowConfigService: WorkflowConfigService,
    private aberrationsServiceNg2: AberrationsService,
    private filterService: FilterService,
    private userService: UserService,
    private aberrationsActionCreator: AberrationsActionCreatorService,
    private filterActionCreatorService: FilterActionCreatorService,
    private diagnosticOrderActionsService: DiagnosticOrderActionsService,
    private modalLoader: DynamicModalLoaderService,
    private pollJobService: PollJobService,
    private aberrationInfoService: AberrationInfoService,
    private practitionerService: PractitionerService,
    private notificationMessageService: NotificationMessageService,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private routerManagerService: RouterManagerService,
    private workflowNavigationService: WorklistNavigationService
  ) {
    /* scroll functionality */
    this.onScroll = () => {
      this.ngZone.run(() => {
        const scrollDemo = document.querySelector('#scrollDiv');
        if (scrollDemo && !this.autoScrollToTop) {
          if ((scrollDemo.scrollTop + scrollDemo.clientHeight) >= (scrollDemo.scrollHeight - 5) && this.endIndex < this.highlighted.length) {
            this.startIndex = this.startIndex + this.buffer;
            this.endIndex = this.endIndex + this.buffer;
            this.getAberrationsFormalized(this.startIndex, this.endIndex);
          } else if (scrollDemo.scrollTop === 0 && this.endIndex > 40) {
            this.startIndex = this.startIndex - this.buffer;
            this.endIndex = this.endIndex - this.buffer;
            scrollDemo.scrollTop = 40;
            this.getAberrationsFormalized(this.endIndex, this.startIndex);
          }
        } else {
          this.autoScrollToTop = false;
        }
      });
    }
  }

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      window.addEventListener('scroll', this.onScroll, true);
    });
    this.transformedData();
    this.stateParams = this.routerManagerService.parameters;
    this.pathologistInfoId = this.authService.user.info.id;
    this.isFilterPanelClose = true;
    this.userService.getPatientForAberration(this.routerManagerService.parameters.patientId).subscribe(res => {
      this.patient = res.body;
    });
    this.currentPatientAnalysis = this.workflowService.currentTest;
    this.isSecondOpinion = this.isSecondOpinionCheck();
    this.workflowConfigService.getActiveWorkflow().subscribe(workflowRequest => {
      this.currentPatientAnalysis.workflowRequest = workflowRequest;

      if (this.testService.activeTab === activeTabObject.GENOMIC_ABERRATIONS) {
        this.initControllerTab();
      }
    });

    let annotationFilter: any = { };

    if (this.testService.testConfiguration.requiredAnnotations) {
      annotationFilter = this.testService.testConfiguration.requiredAnnotations.find(annotation => {
        return annotation.isDefault === true;
      });
    }

    if (annotationFilter) {
      this.aberrationFilter.type = 'aberration';
      this.aberrationFilter.subtype = annotationFilter.type;
      this.aberrationFilter.enableStatistics = true;
    }
  }

  ngAfterViewInit() {
    this.coreActionCreatorService.setLoader(false);
    this.cdr.markForCheck();
  }

  private resetScrollValue() {
    this.startIndex = 0;
    this.endIndex = 39;
  }

  public getModality(modality: string): string {
    return this.translateService.instant('aberration.' + modality);
  }

  private transformedData() {
    this.transformedValue = ' ' + this.translateService.instant(this.GENOMICS_ABERRATIONS_SELECTED);
  }

  private isSecondOpinionCheck(): any {
    return _.find(this.currentPatientAnalysis.workflowRequest.references, (reference) => {
      if (reference.type === 'practitioner') {
        const refValue = JSON.parse(reference.value);
        return reference.type === 'practitioner' && refValue.practType === '2ndOpinion' && refValue.practId === this.pathologistInfoId;
      }
      else {
        return false;
      }
    });
  }

  private initControllerTab() {
    this.resourcesMap = this.aberrationService.getResourcesMap();
    this.testTypeId = this.aberrationService.getTestTypeId();
    this.secondOpinioner = this.aberrationService.getSecondOpinioner();
    this.currentRevision = this.aberrationService.getCurrentRevision();

    this.performer = this.currentPatientAnalysis.performer;
    this.currTest = this.currentPatientAnalysis.workflowRequest;
    this.testConfiguration = this.testService.testConfiguration;
    this.activeJobName = this.currTest.activeJobName;
    this.statusIsAfterInitialResults = this.aberrationService.getStatusIsAfterInitialResults();
    this.isTestFailed = this.isTestFailedCheck();
    this.initAberration();
  }

  private isTestFailedCheck(): any {
    return ['failed'].indexOf(this.currentRevision.status.toLowerCase()) > -1;
  }

  private initAberration() {
    this.aberrationService.initModalitiesMap(this.testConfiguration);
    this.aberrationsCtrl = { };
    this.aberrationsCtrl.secondOpinionsVisible = (!(this.activeJobName.toLowerCase() === 'initialresults' || this.statusIsAfterInitialResults));
    this.igvConfig = this.testService.testConfiguration.IGV;
    this.aberrationsCtrl.updateOpinionOperations = 0;
    this.testService.modalitiesData['currentModality'] = undefined;
    this.currentModality = this.testService.modalitiesData['currentModality'];
    this.aberrationsCtrl.filter = 'all';

    // Note: if no matching template's type is found in the test configuration, refer as default template is used
    this.aberrationsCtrl.exportAberrationsReportEnabled = this.testService.isXhtmlTemplateEnabled(
        this.aberrationService.SELECTED_ABERRATIONS_DEFAULT, true) &&
      this.testService.isTaskDispatchTemplateEnabled(this.aberrationService.SELECTED_ABERRATIONS_DEFAULT, true);

    this.aberrationsCtrl.maxExportAberrationsInReport = _.get(this.testService.testConfiguration, 'maxExportAberrationsInReport', 10000);

    this.workflowService.getWorklfowById(this.stateParams.testId)
      .then(res => res.body)
      .then(workflow => {
        this.immunotherapyEditAllowed = (workflow.activeRevision === this.stateParams.revisionId) &&
          this.currentPatientAnalysis.performer === this.getUserId() &&
          this.testService.testConfiguration.molecularFindings &&
          this.testService.testConfiguration.molecularFindings.editSteps.find(step => step.toLowerCase() === workflow.activeJobName.toLowerCase());
      });

    this.updateSearchLoadingStatus();
    this.updateHighlightedAberration();
    this.onLoadComp();
  }

  public onFilterStateChanges(event) {
    this.isFilterPanelClose = !event;
    this.testService.isFilterPanelClose = this.isFilterPanelClose;
  }

  private getUserId() {
    if (this.authService.user && this.authService.user.info) {
      return this.authService.user.info.id;
    }
    return null;
  }

  private updateSearchLoadingStatus(status?) {
    setTimeout(() => {
      this.searchLoading = status;
      this.cdr.markForCheck();
    });
  }

  private updateHighlightedAberration(updatedAberrationInfo?) {
    setTimeout(() => {
      const index = this.highlighted.findIndex((abb) => abb.id === updatedAberrationInfo?.id);

      // Only updating the fields which were changed in the form
      updatedAberrationInfo?.updated.updated.forEach((updatedField) => {
        this.highlighted[index][updatedField] = updatedAberrationInfo?.updated.form[updatedField];
      });
    });
  }

  private onLoadComp() {
    this.userActionCreatorService.getStoredOrganizationConfiguration()
      .take(1)
      .subscribe((organization) => {
        const orgAllowedRolesFor2ndOpinion = _.get(organization, 'secondOpinion.roles', ['Pathologist', 'Oncologist']);
        const orgAdditionalPropertiesFor2ndOpinion = _.get(organization, 'secondOpinion.additionalProperties', undefined);
        const roles = _.get(this.testConfiguration, 'secondOpinion.roles', orgAllowedRolesFor2ndOpinion);
        const additionalProperties = _.get(this.testConfiguration, 'secondOpinion.additionalProperties', orgAdditionalPropertiesFor2ndOpinion);
        this.secondOpinionForm = this.userService.getPractitionerInputForm(roles, additionalProperties, 'Ask for 2nd Opinion');
      });
    this.listenToFilterMessage();
    this.aberrationService.buildModalityMapObject(this.testConfiguration);
    this.initSorting();
    const currentSelectedFilterQuerySubscriber = this.getFilters(this.ABERRATION_OBJECT_NAME)
      .subscribe(({defaultFilter, appliedFiltersQueries}) => {
        this.handleAberrations(defaultFilter, appliedFiltersQueries);
      });
    this.subscribers.push(currentSelectedFilterQuerySubscriber);

  }

  private listenToFilterMessage() {
    const subscriber = this.aberrationsServiceNg2.getResultMessage()
      .subscribe((msg: Array<string>) => {
        this.updateSearchLoadingStatus(msg.length > 1 && msg[1] === null);
        if (!this.isSorting) {
          this.filteredMessage = msg;
        }
        this.isSorting = false;
      });
    this.subscribers.push(subscriber);
  }

  private initSorting() {
    const displayColumns = this.testConfiguration.displayColumns;
    for (const modality in displayColumns) {
      const columns = displayColumns[modality].filter(f => f.sortable);
      if (columns.length) {
        const defaultSort = columns.filter(c => c.defaultSort === 'true')[0];
        const sort = defaultSort ? defaultSort : columns[0];
        this.tableSortBy[`${modality}`] = {
          all: {
            sortBy: {
              column: sort.columnName,
              dir: true,
              sortAsExpression: sort.sortAsExpression
            }
          },
          selected: {
            sortBy: {
              column: sort.columnName,
              dir: true,
              sortAsExpression: sort.sortAsExpression
            }
          }

        };
      }
    }
  }

  private getFilters(objectName: any): any {
    const aberrationClassByNamesObj = this.aberrationService.getAberrationClassNames(this.testConfiguration.requiredAnnotations);

    let tempFilterTypeAndSubtype: any;

    return this.filterService.getCurrentSelectedFilterQueryFromStore()
      .switchMap(currSelectedQueryObj => this.filterService.getCurrentTypeAndSubtypeFromStore().map(filterTypeAndSubtype => ({
        filterTypeAndSubtype,
        currSelectedQueryObj,
      })))
      .switchMap(({ filterTypeAndSubtype, currSelectedQueryObj}) => {
        tempFilterTypeAndSubtype = filterTypeAndSubtype;
        if (this.onLoad && filterTypeAndSubtype && tempFilterTypeAndSubtype.type === objectName) {
          return this.getFiltersFromStoreAfterServerResponse(objectName, tempFilterTypeAndSubtype.subtype, currSelectedQueryObj);
        } else {
          return Promise.all(this.loadFiltersRequests).then(currFiltersAndQueries => {
            if (!this.onLoad) {
              this.defaultModalityAndData = this.aberrationService.setDefaultModality(
                currFiltersAndQueries.map(filter => filter && filter.defaultFilter),
                this.testConfiguration.requiredAnnotations, this.testService.modalitiesData['currentModality']
              );
              this.setDefaultModality();
            }
            // Trigger ids query for all aberration types with default filters
            this.loadModalities(aberrationClassByNamesObj.aberrationClassNames);
            return this.getFilters(objectName).take(1).toPromise();
          });
        }
      });
  }

  private handleAberrations(defaultFilter: any, appliedFiltersQueries: any) {
    this.defaultModalityAndData = this.aberrationService.setDefaultModality([defaultFilter], this.testConfiguration.requiredAnnotations, this.testService.modalitiesData['currentModality']);

    // first time we load the default modality
    if (!this.onLoad) {
      this.setDefaultModality();
    }

    this.updateIgvFlag();
    this.testService.modalitiesData.filterData[this.selectedModalityType].selectedFilter = cloneDeep(defaultFilter);
    this.testTableData = this.testConfiguration;
    this.testTableData.showNotes = this.testTableData.showNotes || true;

    if (this.testTableData.notesConfig) {
      this.notesConfig = this.testTableData.notesConfig;
    }
    Object.keys(this.testTableData.displayColumns).forEach((aberrationType) =>
      this.aberrationsServiceNg2.setDisplayColumns(aberrationType, this.testTableData.displayColumns[aberrationType])
    );


    // get the current TestConfiguration data
    if (this.testConfigSubscriber) {
      this.testConfigSubscriber.unsubscribe(); // clear subscriber
    }

    this.testConfigSubscriber = this.testService.readTestConfiguration()
      .subscribe((testConfiguration) => {
        testConfiguration.requiredAnnotations
          .map(annotation => {
            this.resourcesConfigs[annotation.type] = Object.assign({ }, annotation);
            this.cdr.markForCheck();
          });
        this.listenToLoader();
        this.listenToAberrationData();
        this.listenToAberrationUpdate();
        const sortBy = this.getSortByForModality(this.testService.modalitiesData['currentModality']);
        this.loadAberrations(
          appliedFiltersQueries,
          this.testTypeId,
          this.testService.modalitiesData['currentModality'],
          sortBy);
        this.loadFilteredAberrationsCount();

        if (defaultFilter && Object.getOwnPropertyNames(defaultFilter).length > 0 && !this.onLoad) {
          const filterTypeAndSubtype = 'aberration_' + this.testService.modalitiesData['currentModality'];
          this.filterService.initSelectedFilterPropsWithSelectedFilterValues(filterTypeAndSubtype, defaultFilter);
        }
        this.setAppliedFilters();
        this.filterAberrationsTableColumns(this.testService.modalitiesData['currentModality']);
      });

    this.subscribers.push(this.testConfigSubscriber); // store subscriber so it could be unsubscribed on destroy
  }

  private getFiltersFromStoreAfterServerResponse(objectName: any, filterSubtype: any, currSelectedQueryObj: any): any {
    let defaultFilter;
    return Promise.all(this.loadFiltersRequests).then(() => {
      return this.filterService.getDefaultFilter(objectName, filterSubtype)
        .do(defaultFilterRes => defaultFilter = defaultFilterRes)
        .flatMap((defaultFilter) => {
          if (defaultFilter) {
            return this.filterService.getSelectedFilterQueryString(objectName, filterSubtype).take(1);
          } else {
            return Observable.of({ });
          }
        })
        .filter(filterQueryString => (filterQueryString || filterQueryString === '') && filterQueryString !== 'null')
        .map(filterQueryString => {
          const appliedFiltersQueries = [{
            filterQueryString: filterQueryString,
            filterType: filterSubtype,
            selectedFilterValues: currSelectedQueryObj
          }];
          return { defaultFilter, appliedFiltersQueries};
        })
        .toPromise();
    });
  }

  private setDefaultModality() {
    this.testService.modalitiesData['currentModality'] = this.defaultModalityAndData.defaultModalityName;
    this.currentModality = this.testService.modalitiesData['currentModality'];
    this.selectedModality = this.defaultModalityAndData.defaultModalityTypeName;
    this.selectedModalityType = this.defaultModalityAndData.defaultModalityName.toLowerCase();
    this.onLoad = true;
  }

  private loadModalities(modalities: any) {
    this.testService.readTestConfiguration()
      .take(1)
      .subscribe(testConfiguration => {
        testConfiguration.requiredAnnotations.forEach(annotation => {
          this.resourcesConfigs[annotation.type] = Object.assign({ }, annotation);
        });

        modalities.forEach((aberrationClass) => {
          this.getFilterByTypeAndSubType(this.ABERRATION_OBJECT_NAME, aberrationClass)
            .toPromise()
            .then(filters => {
              let sortBy;
              if (this.isTableSortedForModality(aberrationClass)) {
                sortBy = this.getSortByForModality(aberrationClass);
              }

              setTimeout(() => {
                return this.loadIdsList(filters, this.testTypeId, aberrationClass, sortBy);
              });

            });
        });
      });
  }

  private updateIgvFlag() {
    this.showIgv = this.igvConfig != null && this.igvConfig.supportedAberrations &&
      this.igvConfig.supportedAberrations.includes(this.selectedModalityType);
  }

  private listenToLoader() {
    if (this.loaderSubscriber) {
      this.loaderSubscriber.unsubscribe();
    }

    this.loaderSubscriber = this.aberrationsActionCreator
      .getState(['loadingStatus'])
      .map(state => state.get(this.getAberrationClassName()))
      .map(loader => loader || loader === undefined)
      .subscribe((loader) => {
        setTimeout(() => {
          this.dataIsLoading = loader;
          this.cdr.markForCheck();
        });
      });
  }

  private listenToAberrationData() {
    if (this.aberrationDataSubscriber) {
      this.aberrationDataSubscriber.unsubscribe();
    }

    this.aberrationDataSubscriber = this.aberrationsServiceNg2.dataRequester$
      .filter(() => [this.modalitiesNames.wildtype].indexOf(this.testService.modalitiesData['currentModality']) === -1)
      .filter(() => {
        const filter = this.aberrationsCtrl.filter.toLowerCase();
        return filter === 'all' || filter === 'selected';
      })
      .filter(data => data.first || (!data.first && data.results.length > 0))
      .map((data) => {
        if (data.first) {
          this.results = [];
        }
        if (!this.aberrationsCtrl.abberationsSearchText && data.first) {
          this.aberrationsServiceNg2.setResultMessage(this.getAberrationClassName(this.testService.modalitiesData['currentModality']), true);
        }
        return data;
      })
      .subscribe((data) => {
        const shouldScroll = data.first || (this.results.length === 0 && data.results.length > 0);
        this.results.push.apply(this.results, data.results);
        setTimeout(() => {
          this.highlighted = this.results;
          this.cdr.markForCheck();
          if (shouldScroll) {
            setTimeout(() => this.moveScrollToTop());
          }
        });

      });
    this.subscribers.push(this.aberrationDataSubscriber);
  }

  private listenToAberrationUpdate() {
    if (this.aberrationUpdateSubscriber) {
      this.aberrationUpdateSubscriber.unsubscribe();
    }

    const subscriber = this.aberrationsServiceNg2.aberrationUpdateSubject
      .subscribe((abbr) => {
        this.updateHighlightedAberration(abbr);
      });
    this.subscribers.push(subscriber);
  }

  private getSortByForModality(modality: any): any {
    const sort = this.tableSortBy[`${modality}`];
    return sort ? this.getFilterSortBy(sort) : { };
  }

  private loadAberrations(filterQuery: any, testTypeId: any, aberrationType: any, sortBy: any) {
    // Results contains aberrations and opinions
    try {
      this.aberrationsCtrl.abberationsSearchText = this.aberrationsCtrl.abberationsSearchText || '';
      if (aberrationType) {
        setTimeout(() => {
          this.loadIdsList(filterQuery, testTypeId, aberrationType, sortBy);
        });
      } else {
        return;
      }

      const aberrationsPromiseArray = [];
      aberrationsPromiseArray.push(this.loadSelectedAberrations());
      aberrationsPromiseArray.push(this.loadAdditionalResources());
      Promise.all(aberrationsPromiseArray)
        .then(() => {
          this.aberrationsCtrl.filter = 'all';
          this.isFirstLoad = false;
          this.getAllOrSelectedAberrations();
          this.updateFilledAberrations();
        });
    } catch (err) {
    }
  }

  private loadFilteredAberrationsCount() {
    this.aberrationsServiceNg2.getAberrationsFilteredResultsCount()
      .subscribe(map => {
        if (map.size) {
          map.keySeq().toArray().forEach(key => {
            if (map.get(key)) {
              if (key === 'Fusion') { // GEN-106575
                this.modalitiesWithResult.add('fusions');
              } else {
                this.modalitiesWithResult.add(key.toLowerCase());
              }
            } else {
              this.modalitiesWithResult.delete(key.toLowerCase());
            }
          });
          this.cdr.markForCheck();
        }
      });
  }

  private setAppliedFilters() {
    if (!this.alreadySubscribed) {
      this.appliedFilterPropertiesSubscriber = this.filterService.getAppliedFilterPropertiesFromStore().subscribe((appliedFilterProperties) => {
        this.appliedFilters = appliedFilterProperties;
        this.alreadySubscribed = true;
        this.cdr.markForCheck();
      });
    }
  }

  private filterAberrationsTableColumns(modality: any) {
    const columns = this.testConfiguration.displayColumns[modality];
    if (!columns) {
      return columns;
    }
    this.testConfiguration.displayColumns[modality] = columns.filter(column => {
      if (column.hidden) {
        return false;
      }
      if (column.hideOnState && this.currentRevision && this.currentRevision.status) {
        const currentStatus = this.currentRevision.status;
        return column.hideOnState.indexOf(currentStatus.toLowerCase()) === -1;
      }
      return true;
    });
  }

  private getFilterByTypeAndSubType(filterType: any, filterSubtype: any): any {
    return this.filterService.getSelectedFilterQueryString(filterType, filterSubtype)
      .take(1)
      .flatMap(filterQueryString => {
        return this.filterActionCreatorService.getCurrentSelectedFilterQuery([filterType, filterSubtype].join('_'))
          .take(1)
          .map(selectedFilterValues => ({ filterQueryString, selectedFilterValues}));
      })
      .map(({ filterQueryString, selectedFilterValues}) => {
        return [{
          filterQueryString,
          filterType: filterSubtype,
          selectedFilterValues
        }];
      });
  }

  private isTableSortedForModality(modality: any): any {
    return !_.isEmpty(this.tableSortBy[`${modality}`]);
  }

  private loadIdsList(filterQuery: any, testTypeId: any, aberrationType: any, sortBy: any) {
    const aberrationClassType = this.getAberrationClassName(aberrationType);
    if (aberrationType === this.testService.modalitiesData['currentModality']) {
      this.aberrationsServiceNg2.setResultMessage(aberrationClassType, false);
    }
    let filter;
    if (filterQuery && filterQuery.find) {
      filter = filterQuery.find(filter => filter.filterType && filter.filterType.toLowerCase() === aberrationType.toLowerCase());
    }
    this.aberrationsServiceNg2.getAberrationsListByType(
      this.currTest.id,
      this.resourcesMap.Aberration || this.resourcesMap.firstRevision,
      aberrationType,
      aberrationClassType,
      filter,
      testTypeId,
      true,
      0,
      this.aberrationsServiceNg2.getIdsChunkAmount(),
      this.resourcesMap.requestedRevision,
      sortBy
    )
      .map(data => {
        const selectedFilters = filter && filter.selectedFilterValues ? Object.assign({ }, filter.selectedFilterValues) : '';
        this.testService.modalitiesData['modalitiesMap'][aberrationType].results.aberrations = this.testService.modalitiesData['modalitiesMap'][aberrationType].results.aberrations.concat(data.ids);
        this.testService.modalitiesData['modalitiesMap'][aberrationType].selectedFilters = selectedFilters;
        return data;
      })
      .filter(() => aberrationType === this.testService.modalitiesData['currentModality'])
      .subscribe(
        () => {
          this.getAberrationsFormalized(0, 0, false, sortBy);
        },
        () => {
          return { page: null, ids: [], last: true};
        },
        () => {
          if (aberrationType === this.testService.modalitiesData['currentModality']) {
            this.aberrationsServiceNg2.setResultMessage(aberrationClassType, true);
            this.setSelectedAberrationsNumberForCurrentModality();
          }
        });
  }

  private getAberrationClassName(aberrationType?: any): any {
    aberrationType = aberrationType || this.testService.modalitiesData['currentModality'];
    return aberrationType
    && this.resourcesConfigs[aberrationType]
    && this.resourcesConfigs[aberrationType].aberrationClass
      ? this.resourcesConfigs[aberrationType].aberrationClass
      : null;
  }

  private moveScrollToTop() {
    this.autoScrollToTop = true;
    const scrollElement = document.querySelector('#scrollDiv');
    while(this.endIndex > 40) {
        this.startIndex = this.startIndex - this.buffer;
        this.endIndex = this.endIndex - this.buffer;
        scrollElement.scrollTop = 0;
        this.getAberrationsFormalized(this.endIndex, this.startIndex);
    }
  }

  private getFilterSortBy(sort): any {
    if (this.aberrationsCtrl.filter === 'selected') {
      return sort.selected.sortBy;
    }
    return sort.all.sortBy;
  }

  private loadSelectedAberrations(sortBy = { }): any {
    return new Promise((resolve, reject) => {
      if (!this.isFirstLoad) {
        return resolve(null);
      }
      const modalitiesMap = this.aberrationService.buildModalityMapObject(this.testConfiguration);
      // selected aberration shouldn't affect from the current filter,
      const query = Object.keys(modalitiesMap).reduce((arr, key) => {
        if (modalitiesMap[key].itemType.toLowerCase() === 'aberrationtype') {
          arr.push({
            filterQueryString: '',
            filterType: key,
            selectedFilterValues: { }
          });
        }
        return arr;
      }, []);

      this.diagnosticOrderActionsService.getState('order').take(1).subscribe(
        (order: any) => {
          this.aberrationService.getAll(
            this.currTest.id,
            this.resourcesMap.Aberration || this.resourcesMap.firstRevision,
            this.currentRevision.id,
            this.pathologistInfoId,
            order.performer,
            query,
            true,
            this.testTypeId,
            modalitiesMap,
            sortBy)
            .subscribe(
              (res) => {
                for (const type in res.body.modalitiesMap.map) {
                  res.body.modalitiesMap.map[type].selectedResults.selectedAberrations
                    .forEach(aberration => aberration.collapsed = true);
                }

                this.setModalitiesAberrations(res.body.modalitiesMap.map, 'selectedResults');
                this.aberrationsCtrl.opinions = res.body.modalitiesMap.opinions;
                this.handleOpinions();
                this.setSelectedAberrationsNumber();
                resolve(null);
              },
              () => {
                reject();
              }
            );
        }
      );
    });
  }

  private loadAdditionalResources(): any {
    if (!this.isFirstLoad || this.aberrationsServiceNg2.init['additional']) {
      this.updateWildTypesState();
      return Promise.resolve();
    }
    else {
      return this.aberrationService.getAdditionalResources(
        this.testConfiguration.id,
        this.resourcesMap.Aberration || this.resourcesMap.firstRevision,
        this.routerManagerService.parameters.testId)
        .subscribe((res) => {
          this.aberrationsServiceNg2.init['additional'] = true;
          const fieldsToUpdate = Object.keys(res.body).map(key => this.testService.modalitiesData['modalitiesMap'][key].itemType);
          this.setModalitiesAberrations(res.body, 'results', fieldsToUpdate);
          this.updateWildTypesState();
        });
    }
  }

  private getAllOrSelectedAberrations() {
    if (this.aberrationsServiceNg2.init[this.getAberrationClassName()]) {

      if (this.aberrationsCtrl.filter === 'all') {
        this.getAberrationsFormalized();
        this.moveScrollToTop();
      } else if (this.aberrationsCtrl.filter !== 'all') {
        this.highlighted = this.testService.modalitiesData
          ['modalitiesMap'][this.testService.modalitiesData['currentModality']]
          .selectedResults.selectedAberrations;
        this.cdr.markForCheck();
        this.moveScrollToTop();
      }
    }
  }

  private updateWildTypesState() {
    if (this.wtCalculationMethod('Selection based') && !this.isSecondOpinion) {
      const wtList = this.testService.modalitiesData['modalitiesMap'][this.modalitiesNames.wildtype].results.aberrations;
      const selectedGenes = [];
      for (const modalityMapName in this.testService.modalitiesData['modalitiesMap']) {
        const modalityMap = this.testService.modalitiesData['modalitiesMap'][modalityMapName];
        if (modalityMap.itemType === 'aberrationType' && modalityMap.selectedResults && modalityMap.selectedResults.selectedAberrations &&
          modalityMap.selectedResults.selectedAberrations.length > 0) {
          for (const selectedAberration in modalityMap.selectedResults.selectedAberrations) {
            if ((modalityMap.selectedResults.selectedAberrations[selectedAberration].id in this.aberrationsCtrl.currentOpinion?.selections) &&
              this.aberrationsCtrl.currentOpinion?.selections[modalityMap.selectedResults?.selectedAberrations[selectedAberration].id]) {
              selectedGenes.push(modalityMap.selectedResults.selectedAberrations[selectedAberration][this.getGenePropertyName(modalityMapName)]);
            }
          }
        }
      }

      const uniqueSelectedGenes = _.uniq(selectedGenes);
      let shouldUpdateMolecularFindingResource = false;
      const originalWTList = _.cloneDeep(wtList);
      const originalMolecularFindingResource = _.cloneDeep(this.testService.modalitiesData['modalitiesMap'][this.modalitiesNames.wildtype].results.molecularFindingResource);

      for (const wildType in wtList) {
        const geneName = wtList[wildType].gene;
        const isWTCandidate = wtList[wildType].WTdescription === 'yes';
        if ((uniqueSelectedGenes.includes(geneName) && isWTCandidate) || (!uniqueSelectedGenes.includes(geneName) && !isWTCandidate)) {
          this.updateSpecificWildTypeLocaly(wtList[wildType], isWTCandidate);
          this.updateMolecularFindingLocaly(geneName, isWTCandidate);
          shouldUpdateMolecularFindingResource = true;
        }
      }

      if (shouldUpdateMolecularFindingResource) {
        this.aberrationService.saveMolecularFinding(
          this.currentRevision.id,
          this.testService.modalitiesData['modalitiesMap'][this.modalitiesNames.wildtype].results.molecularFindingResource
        )
          .subscribe(
            () => { },
            () => {
              this.testService.modalitiesData['modalitiesMap'][this.modalitiesNames.wildtype].results.aberrations = originalWTList;
              this.testService.modalitiesData['modalitiesMap'][this.modalitiesNames.wildtype].results.molecularFindingResource
                = originalMolecularFindingResource;
            }
          );
      }
    }
  }

  private wtCalculationMethod(method): any {
    return this.testConfiguration.reviewTestResults && this.testConfiguration.reviewTestResults.wtCalculationMethod &&
    this.testConfiguration.reviewTestResults.wtCalculationMethod === method;
  }

  private updateFilledAberrations() {
    const abrObj = this.testService.modalitiesData['modalitiesMap'];
    for (const prop in abrObj) {
      if (prop === 'immunotherapy' || 'other_biomarker') {
        if (this.isImmunotherapyFilled(abrObj[prop].results)) {
          this.modalitiesWithResult.add(prop);
        }
      } else if (abrObj[prop].results.aberrations.length) {
        this.modalitiesWithResult.add(prop);
      }
    }
    this.cdr.markForCheck();
  }

  public getAberrationsFormalized(start = 0, offset = 0, force = false, sortBy?: any) {
    const isSearchMode = (!!this.aberrationsCtrl.abberationsSearchText);
    if (!force && (isSearchMode || (!(start % (this.aberrationsServiceNg2.getChunkSize() / 2) === 0
      && (start + offset > this.results.length || start + offset === 0))))) {
    }
    else if (offset === 0) {
      this.results = [];
    }
    if (!sortBy) {
      // This was added to support paging. Without this, when scrolling to the next page sort will be undefined and the next page will not be sorted.
      sortBy = this.currentTableSortBy();
    }
    this.aberrationsServiceNg2.dataRequestEmit(
      this.currTest.id,
      this.testService.modalitiesData['currentModality'],
      this.getAberrationClassName(this.testService.modalitiesData['currentModality']),
      this.aberrationsCtrl.abberationsSearchText,
      this.testTypeId,
      this.resourcesMap.Aberration || this.resourcesMap.firstRevision,
      this.results.length,
      offset,
      this.resourcesMap.requestedRevision,
      sortBy
    );
  }

  private handleOpinions() {
    let secondOpinionOp = _.find(this.aberrationsCtrl.opinions, (op) => {
      return op.isSecondOpinion;
    })
    this.aberrationsCtrl.IsExistSecondOpinion = !!secondOpinionOp;

    let lastReviewIndex = _.findLastIndex(this.aberrationsCtrl.opinions, (opinion: any) => {
      return opinion.practitioner.reference === this.pathologistInfoId && !(!this.aberrationsCtrl.secondOpinionsVisible && opinion.state === 'confirmed');
    });
    if (lastReviewIndex == -1) {
      lastReviewIndex = this.aberrationsCtrl.opinions.length - 1;
    }
    this.aberrationsCtrl.currentOpinion = this.aberrationsCtrl.opinions[lastReviewIndex];
    // Get practitoners info for each review - gets practitioner name
    _.each(this.aberrationsCtrl.opinions, (opinion) => {
      this.practitionerService.get(opinion.practitioner.reference).subscribe((res) => {
        opinion.practitioner.name = res.body.name[0].given[0] + ' ' + res.body.name[0].family[0];
      });
    });
  }

  private setSelectedAberrationsNumberForCurrentModality() {
    let selectedAberration;
    let num = 0;
    if (this.aberrationsCtrl.currentOpinion) {
      for (const type in this.aberrationsCtrl.currentOpinion.selections) {
        if (this.testService.modalitiesData['modalitiesMap'][this.testService.modalitiesData['currentModality']]
          && this.testService.modalitiesData['modalitiesMap'][this.testService.modalitiesData['currentModality']].selectedResults) {
          selectedAberration = _.find(this.testService.modalitiesData['modalitiesMap'][this.testService.modalitiesData['currentModality']].selectedResults.selectedAberrations, (aberration) => {
            return aberration.id === type;
          });
          if (this.aberrationsCtrl.currentOpinion.selections[type] && selectedAberration) { num++; }
          selectedAberration = null;
        }
      }
      this.aberrationsCtrl.numberOfSelectedAberrations = num;
    } else {
      this.aberrationsCtrl.numberOfSelectedAberrations = 0;

    }
  }

  private setModalitiesAberrations(modalitiesMap: any, objectName: any, updateTypes = ['aberrationType']) {
    let numSelected = 0;

    for (const modality in modalitiesMap) {
      const modalityData = this.testService.modalitiesData['modalitiesMap'][modality];

      if (modalityData && updateTypes.indexOf(modalityData.itemType) > -1) {
        modalityData[objectName] = modalitiesMap[modality][objectName];
      }

      if (modalityData.selectedResults && modalityData.selectedResults.selectedAberrations) {
        numSelected += modalityData.selectedResults.selectedAberrations.length;
      }

    }

  }

  private getGenePropertyName(modality: any): any {
    switch (modality) {
      case 'snv':
        return 'HGNC_gene';
      case 'cnv':
        return 'Gene';
    }
  }

  private updateSpecificWildTypeLocaly(wt: any, select: any) {
    wt.isWTCandidate = !select;
    wt.WTdescription = select ? 'no' : 'yes';
  }

  private updateMolecularFindingLocaly(geneName: any, toSelect: any) {
    const wtCandidates = this.testService.modalitiesData['modalitiesMap'][this.modalitiesNames.wildtype].results.molecularFindingResource?.WTCandidates;
    if (wtCandidates === undefined || wtCandidates.length === 0) {
      return false;
    }
    const wtIndex = _.findIndex(wtCandidates, (wt: any) => wt.gene === geneName);
    if (wtIndex !== -1) {
      wtCandidates[wtIndex].isWT = !toSelect;
      wtCandidates[wtIndex].WTdescription = toSelect ? 'no' : 'yes';
      return true;
    }
    return false;
  }

  private isImmunotherapyFilled(immunotherapy: any): any {
    for (const i in immunotherapy) {
      if (immunotherapy[i].edit) {
        let value = immunotherapy[i].edit.value || '';
		let level = immunotherapy[i].edit.level || '';
        if (_.isString(value)) {
          value = value.length;
        }
        if (value > 0 || level.length > 0) {
          return true;
        }
      } else if (immunotherapy[i].value) {
        let value = immunotherapy[i].value;
        if (_.isString(value)) {
          value = value.length;
        }
        if (value > 0) {
          return true;
        }
      }
    }
    return false;
  }

  private currentTableSortBy(): any {
    const modality = this.currentModality;
    const sort = this.tableSortBy[`${modality}`];

    return sort ? this.getFilterSortBy(sort) : { };
  }

  public selectModality(modality: any) {
    this.resetScrollValue();
    if (this.testService.modalitiesData['currentModality'] !== modality.type) {
      this.alreadySubscribed = false;
      if (this.appliedFilterPropertiesSubscriber) {
        this.appliedFilterPropertiesSubscriber.unsubscribe();
      }
      if (modality.type !== 'immunotherapy' && modality.type !== 'wildtype') {
        this.filterService.setFilterType('aberration', modality.type);
      }
      this.testService.modalitiesData['currentModality'] = modality.type;
      this.currentModality = this.testService.modalitiesData['currentModality'];
      this.aberrationsCtrl.filter = 'all';
      this.listenToLoader();
      this.aberrationsCtrl.abberationsSearchText = '';
      this.highlighted = [];
      this.selectedModality = modality.name;
      this.selectedModalityType = modality.type.toLowerCase();
      this.updateIgvFlag();

      if ([this.modalitiesNames.wildtype, 'aberrationtype'].indexOf(modality.name.toLowerCase()) >= 0) {
        this.setSelectedAberrationsNumber();
        this.isToshowFiltersRefineMsg = this.testService.modalitiesData['modalitiesMap'][this.testService.modalitiesData['currentModality']].results.isToshowFiltersRefineMsg;

        if (_.isEmpty(this.testService.modalitiesData.filterData[this.testService.modalitiesData['currentModality']].selectedFilter)) {
          if (modality.type !== 'immunotherapy' && modality.type !== 'wildtype') {
            this.filterService.getDefaultFilter('aberration', modality.type)
              .subscribe((defaultFilter) => {
                this.testService.modalitiesData.filterData[this.testService.modalitiesData['currentModality']].selectedFilter = cloneDeep(defaultFilter);
              });
          }
        }

        setTimeout(() => {
          if ([this.modalitiesNames.wildtype].indexOf(modality.name.toLowerCase()) > -1) {
            this.aberrationsActionCreator.setLoadingStatus(this.getAberrationClassName(this.testService.modalitiesData['currentModality']), false);
            this.aberrationsServiceNg2.setResultMessage(this.testService.modalitiesData['currentModality'], true, this.highlighted.length);
            this.highlighted = [];
            if (Array.isArray(this.testService.modalitiesData['modalitiesMap'][this.testService.modalitiesData['currentModality']].results.aberrations)) {
              this.highlighted = this.testService.modalitiesData['modalitiesMap'][this.testService.modalitiesData['currentModality']].results.aberrations.map((result) => {
                result.id = result.gene;
                this.cdr.markForCheck();
                return result;
              }) || [];
            }
            setTimeout(() => {
              this.moveScrollToTop();
            });
          } else {
            this.getAllOrSelectedAberrations();
          }
          this.setAppliedFilters();
        });
      } else {
        this.aberrationsCtrl.results = this.testService.modalitiesData['modalitiesMap'][this.testService.modalitiesData['currentModality']].results;
        this.aberrationsActionCreator.setLoadingStatus(this.testService.modalitiesData['currentModality'], false);
      }
    }
  }

  public setSelectedAberrationsNumber(requestModality?: any) {
    if (!requestModality || requestModality === this.testService.modalitiesData['currentModality']) {
      this.setSelectedAberrationsNumberForCurrentModality();
    }
    this.checkIfAnyAberrationSelected();
    this.loadModalityContent = true;
    this.cdr.markForCheck();
  }

  public checkIfAnyAberrationSelected() {
    let selectedAberration;
    this.aberrationsCtrl.isAnyAberrationSelected = false;

    if (this.aberrationsCtrl.currentOpinion) {
      for (const type in this.aberrationsCtrl.currentOpinion.selections) {
        for (const modalityType in this.testService.modalitiesData['modalitiesMap']) {
          selectedAberration = _.find(this.testService.modalitiesData['modalitiesMap'][modalityType].selectedResults.selectedAberrations, (aberration) => {
            return aberration.id === type;
          });
          if (this.aberrationsCtrl.currentOpinion.selections[type] && selectedAberration) {
            this.aberrationsCtrl.isAnyAberrationSelected = true;
            return;
          }
          selectedAberration = null;
        }
      }
    }
  }

  public updateValues(update: any, modality: any) {
    Object.assign(this.testService.modalitiesData['modalitiesMap'][modality].results, update);
  }

  public getAllAberrations() {
    if (this.aberrationsCtrl.filter !== 'all') {
      this.moveScrollToTop();
      setTimeout(() => {
        this.aberrationsCtrl.filter = 'all';
        if (this.isTableSortedForModality(this.currentModality)) {
          this.getFilterByTypeAndSubType(this.ABERRATION_OBJECT_NAME, this.currentModality)
            .take(1)
            .subscribe(filters => {
              const tableSortBy = this.currentTableSortBy();
              this.loadIdsList(filters, this.testTypeId, this.currentModality, tableSortBy);
            });
        } else {
          this.getAllOrSelectedAberrations();
        }

      });
    }
  }

  public getSelectedAberrations() {
    if (this.aberrationsCtrl.filter !== 'selected') {
      this.moveScrollToTop();
      this.isFirstLoad = false;
      setTimeout(() => {
        this.aberrationsCtrl.filter = 'selected';
        this.aberrationsCtrl.abberationsSearchText = '';

        if (this.isTableSortedForModality(this.currentModality)) {
          const tableSortBy = this.currentTableSortBy();
          tableSortBy.modality = this.currentModality;
          this.isFirstLoad = true;
          this.loadSelectedAberrations(tableSortBy)
            .then(() => {
              this.isFirstLoad = false;
              this.dataIsLoading = false;
              this.cdr.markForCheck();
              this.getAllOrSelectedAberrations();
            });
        } else {
          this.getAllOrSelectedAberrations();
        }
      });
    }
  }

  public edit() {
    this.saveState('review');
  }

  public saveState(state: string) {
    return this.aberrationService.saveState(this.aberrationsCtrl.currentOpinion.id, state, this.currentRevision.id)
      .subscribe(
        () => {
          this.aberrationsCtrl.currentOpinion.state = state;
          this.cdr.markForCheck();
        },
        () => {
          this.notificationMessageService.error('unable to save');
        }
      );
  }

  public cancel() {
    this.aberrationsCtrl.abberationsSearchText = '';
    this.getAberrationsFormalized(0, 0, true);
  }

  public search(searchValue: any) {
    this.results = [];
    this.aberrationsCtrl.abberationsSearchText = searchValue;
    this.getAberrationsFormalized(0, 0, true);
  }

  public canPerformTestActions(): any {
    const userId = this.getUserId();
    const secondOpinionRef = this.currentPatientAnalysis.workflowRequest.references.find(ref => {
      let val;
      try {
        val = JSON.parse(ref.value);
      } catch (e) {
        return false;
      }
      return val.practId && val.practId === userId && val.practType && val.practType === '2ndOpinion';
    });
    return (!this.revisionInDisabledStatuses(this.currentRevision)) && (this.currentPatientAnalysis.performer === userId || !!secondOpinionRef);
  }

  public revisionInDisabledStatuses(revision: any): any {
    const disabledStatuses = ['test completed', 'cancelled', 'canceled', 'failed'];
    return disabledStatuses.find((status) => revision.status.toLowerCase() === status) !== undefined;
  }

  public jumpToInterpretation(): any {
    return this.testConfiguration.reviewTestResults && this.testConfiguration.reviewTestResults.jumpToInterpretation;
  }

  public canProceedWithoutAberrationSelection(): any {
    return this.testConfiguration.reviewTestResults && this.testConfiguration.reviewTestResults.canProceedWithoutAberrationSelection;
  }

  public confirm() {
    const falseAberrations = _.filter(this.testService.modalitiesData['modalitiesMap'][this.testService.modalitiesData['currentModality']].results.aberrations, (aberration) => {
      return this.aberrationsCtrl.currentOpinion.selections[aberration.id] === undefined;
    }).map((aberration) => {
      return { id: aberration.id, selection: false};
    });

    // If there are undefined we save the bulk
    if (falseAberrations.length > 0) {
      this.aberrationService.saveSelectionBulk(falseAberrations, this.aberrationsCtrl.currentOpinion.id)
        .subscribe((res) => {
          if (res.status === 200) {
            _.each(falseAberrations, (aberration) => {
              this.aberrationsCtrl.currentOpinion.selections[aberration.id] = false;
            });
          }

          // Change state to confirmed
          this.saveState('confirmed');
        });
    } else {
      this.saveState('confirmed');
    }
  }

  public proceedWithSelectedAberrations() {
    if (!this.clickedOnProceedWithSelectedAberrations) {
      let abrMessage = 'selected';
      if (this.canProceedWithoutAberrationSelection() && !this.aberrationsCtrl.isAnyAberrationSelected) {
        abrMessage = 'no';
      }
      let title = this.getProceedWithSelectedAberrationsTitle();

      let messageContent = this.translateService.instant('Are you sure you want to proceed with ' + abrMessage + ' aberrations?') ||  'Are you sure you want to proceed with ' + abrMessage + ' aberrations?';
      let confirmButton = this.translateService.instant('OK') || 'OK';
      let cancelButton = this.translateService.instant('Cancel') ||  'Cancel';

      if (this.testConfiguration.filterPartialAndNonCuratedAberrations && this.testConfiguration.proceedWithSelectedAberrationsButton) {
        if (
          this.testService.modalitiesData['modalitiesMap'][this.currentModality].selectedResults.selectedAberrations
          .some(aberration => !aberration.manualCurationStatus || aberration.manualCurationStatus === 'PendingCuration' || aberration.manualCurationStatus.partiallyCurated)
        ) {
          messageContent = this.testConfiguration.proceedWithSelectedAberrationsButton.messageContent;
          title = this.testConfiguration.proceedWithSelectedAberrationsButton.messageTitle;
          confirmButton = this.testConfiguration.proceedWithSelectedAberrationsButton.confirmButton;
          cancelButton = this.testConfiguration.proceedWithSelectedAberrationsButton.cancelButton;
        }
      }

      this.clickedOnProceedWithSelectedAberrations = true;

      this.modalLoader.popupModal(
        ConfirmModalComponent,
        {
          title: title,
          content: messageContent,
          approveBtn: confirmButton,
          declineBtn: cancelButton
        },
        ModalTypes.NONE
      )
        .subscribe((response) => {
          if (response && response.payload) {
            if (response.payload === 1) {
              this.loadModalityContent = false;
              this.currentPatientAnalysis.opinions = this.getCurrentPerformerOpinion();
              this.currentPatientAnalysis.localDateTime = this.testService.getLocalDateTime();
              this.currentPatientAnalysis.localTime = this.testService.getLocalTime();
              this.currentPatientAnalysis.clientTimeZone = new Date().getTimezoneOffset();

              this.currentPatientAnalysis.user = this.authService.user;
              const workflowRequestId = this.currentPatientAnalysis.workflowRequest && this.currentPatientAnalysis.workflowRequest.id;

              this.workflowService.performWorkflowStep(
                this.currentPatientAnalysis,
                this.getProceedWithSelectedAberrationsStep(),
                '',
                this.currentRevision.id,
                workflowRequestId,
                false
              ).then(workflowStepResponse => {
                if (workflowStepResponse.body.message === 'missing Required Information') {
                    const dialogMessage = 'Required information for test info is missing';
                    this.modalLoader.popupModal(
                      ConfirmModalComponent,
                      {
                        content: dialogMessage,
                        approveBtn: 'OK',
                      },
                      ModalTypes.ALERT
                    )
                      .subscribe();
                  } else {
                  const workflowId = this.routerManagerService.parameters.testId || this.stateParams.testId;

                  return this.workflowConfigService.getCurrentActiveWorkflow().toPromise()
                    .then((activeWorkflow: IWorkflow) => this.pollJobService.waitForWorkflowCondition(workflowId, this.currentRevision.id,
                        workflow => workflow.activeJobName !== activeWorkflow.activeJobName, 2000, 20)
                    )
                    .then(workflow => {
                      if (workflow.activeJobName.toLowerCase().includes('fail')) {
                        throw new Error('Can\'t perform workflow step');
                      }
                      this.testService.activeTab = activeTabObject.GENOMIC_ABERRATIONS;

                  this.setDefaultAnnotations();

                      if (this.getMoveToApproved() ||
                        this.canProceedWithoutAberrationSelection() && !this.aberrationsCtrl.isAnyAberrationSelected
                      ) {
                    this.saveState('approved');
                  }
                      this.routerManagerService.reload();
                    });
                }
              })
              .catch(error => {
                console.error(error);
                this.notificationMessageService.error('unable to proceed with aberrations: ' + error);
              });

            } else {
              this.clickedOnProceedWithSelectedAberrations = false;
              this.cdr.markForCheck();
            }
          }
        });
    }
  }

  public getCurrentPerformerOpinion(): any {
    const opinionsCopy = Array.from(this.aberrationsCtrl.opinions).reverse();
    return _.find(opinionsCopy, (op: any) => {
      if (op.practitioner.reference === this.performer) {
        return op;
      }
    });
  }

  public getProceedWithSelectedAberrationsStep(): any {
    return _.get(this.testConfiguration, 'proceedWithSelectedAberrationsButton.workflowStep', (this.translateService.instant(this.DEFAULT_PROCEED_WITH_SELECTED_ABERRATIONS) || this.DEFAULT_PROCEED_WITH_SELECTED_ABERRATIONS));
  }

  public getMoveToApproved(): any {
    return _.get(this.testConfiguration, 'releaseReportButton.moveToApproved');
  }

  public getProceedWithSelectedAberrationsTitle(): any {
    return _.get(this.testConfiguration, 'proceedWithSelectedAberrationsButton.title', (this.translateService.instant(this.PROCEED_WITH_SELECTED_ABERRATIONS_TITLE) || this.PROCEED_WITH_SELECTED_ABERRATIONS_TITLE));
  }

  public aberrationsReviewToInterpretationJump() {
    let modalPayload = {
      isAnyAberrationSelected: this.aberrationsCtrl.isAnyAberrationSelected
    }
    this.modalLoader.popupModal(PlaceholderModalComponent,
      {
        title: this.translateService.instant('Release for interpretation') || 'Release for interpretation',
        componentToLoad: ReleaseInterpretationComponent,
        buttons: {
          approveBtn: 'OK', declineBtn: 'Cancel'
        },
        payload: {
          modalPayload
        },
        approveCallback: () => {
          const providers = this.getInterpretationProviders();
          const falseAberrations = _.filter(this.testService.modalitiesData['modalitiesMap'][this.testService.modalitiesData['currentModality']].results.aberrations, (aberration) => {
              return this.aberrationsCtrl.currentOpinion.selections[aberration.id] === undefined;
          }).map((aberration) => {
            return { id: aberration.id, selection: false};
          });

          // If there are undefined we save the bulk
          if (falseAberrations.length > 0) {
            this.aberrationService.saveSelectionBulk(falseAberrations, this.aberrationsCtrl.currentOpinion.id)
              .subscribe((res) => {
                  if (res.status === 200) {
                  _.each(falseAberrations, (aberration) => {
                    this.aberrationsCtrl.currentOpinion.selections[aberration.id] = false;
                  });
                }

                // Change state to confirmed
                this.saveState('approved');
              });
          } else {
            this.saveState('approved');
          }

          this.currentPatientAnalysis.opinions = this.getCurrentPerformerOpinion();
          this.currentPatientAnalysis.user = this.authService.user;
          this.workflowService.performWorkflowStep(this.currentPatientAnalysis, 'aberration review jump to interpretation', '', this.currentRevision.id, undefined, undefined, undefined, { providers}).then(() => {
            this.testService.activeTab = activeTabObject.GENOMIC_ABERRATIONS;
            this.routerManagerService.reload();
          });
          return Observable.of(true);
        },
      }, ModalTypes.NONE).subscribe();

  }

  public getInterpretationProviders() {
    return this.providers && this.providers.reduce((arr, provider) => {
      if (provider.enabled) {
        arr.push(provider.code);
      }
      return arr;
    }, []);
  }

  public exportAberrationsToExcel() {
    this.modalLoader.popupModal(ConfirmModalComponent,
      {
        title: 'Export Selected Aberrations to Excel',
        content: this.getExportAberrationsModalHtml(),
        approveBtn: 'OK',
        declineBtn: 'Cancel'
      }, ModalTypes.NONE).subscribe(response => {
      if (response && response.payload && response.payload === 1) {
        this.dataIsLoading = true;

        this.aberrationService.exportAberrationsToExcel(this.testConfiguration.id, this.resourcesMap.requestedRevision, this.aberrationsCtrl.maxExportAberrationsInReport)
          .subscribe(
            () => {
              const messageSuccess = this.translateService.instant('Successfully exported selected aberrations to an Excel file') || 'Successfully exported selected aberrations to an Excel file'
              this.notificationMessageService.success(messageSuccess);

              // refresh page so attachments will be updated with the new exported file
              this.routerManagerService.reload();
            },
            (err) => {
              const message = this.translateService.instant('Failed to export selected aberrations to an Excel file') ||  'Failed to export selected aberrations to an Excel file';
              console.error(message + '\n' + err);
              this.notificationMessageService.error(message);
              this.dataIsLoading = false;
            }
          );
      }
    });

  }

  public getExportAberrationsModalHtml(): string {
    const numSelected = this.getNumSelectedAberrations();
    let tempHtml = '';
    if (numSelected > this.aberrationsCtrl.maxExportAberrationsInReport) {
      tempHtml = ' but maximum ' + this.aberrationsCtrl.maxExportAberrationsInReport + ' will be included';
    }

    return `Are you sure you want to export the selected aberrations? \ ${numSelected}\ aberrations are selected \ ${tempHtml}\ `;
  }

  public getNumSelectedAberrations(): any {
    const OpinionSelAberrs = _.get(this.aberrationsCtrl, 'currentOpinion.selectedAberrations');
    if (OpinionSelAberrs) {
      return Object.keys(OpinionSelAberrs).length;
    }
    return 0;
  }

  public getExportAberrationsTooltip() {
    const numSelected = this.getNumSelectedAberrations();
    if (numSelected === 0) {
      return null;
    }

    let tooltip;

    if (numSelected > this.aberrationsCtrl.maxExportAberrationsInReport) {
      tooltip = this.aberrationsCtrl.maxExportAberrationsInReport + ' out of ' + numSelected;
    } else {
      tooltip = numSelected;
    }

    return 'Export ' + tooltip + ' Aberrations';
  }

  public sendSecondOpinion() {
    if (!this.send2NdOpinionDialogIsOpen) {
      this.send2NdOpinionDialogIsOpen = true;

      this.modalLoader.popupModal(ConfirmModalComponent,
        {
          title: '2<sup>nd</sup> Opinion send',
          content: 'Are you sure you want to send your 2nd opinion? ',
          approveBtn: 'OK',
          declineBtn: 'Cancel'
        }).subscribe(response => {
        if (response && response.payload) {
          this.send2NdOpinionDialogIsOpen = false;
          if (response.payload === 1) {

            this.workflowService.getPatientAnalyses({
              revisionId: this.currentRevision.id,
              patientId: this.routerManagerService.parameters.patientId,
              testId: this.currTest.id
            }, true).then((res) => {

              this.currentPatientAnalysis = res.body.current;
              if (!this.isSecondOpinion) {
                this.modalLoader.popupModal(ConfirmModalComponent,
                  {
                    title: '2<sup>nd</sup> Opinion request was cancelled',
                    content: 'The request for 2<sup>nd</sup> &nbsp;opinion was cancelled, you are redirected to your work list',
                    approveBtn: 'OK'
                  }).subscribe(response1 => {
                  if (response1) {
                        this.router.navigate(['Pathologist'])
                  }
                });

              } else {
                this.workflowService.
                performWorkflowStep(this.currentPatientAnalysis, '2nd opinion review', this.pathologistInfoId, this.currentRevision.id).then(() => {
                  this.filterService.setFilterType('UIPractWorkListRow', 'TestWorklist');
                  this.modalLoader.popupModal(ConfirmModalComponent,
                    {
                      title: '2<sup>nd</sup> Opinion request successfully sent',
                      content: 'The request for 2<sup>nd</sup> &nbsp;opinion was sent',
                      approveBtn: 'OK'
                    }).subscribe(response1 => {
                    if (response1) {
                      this.workflowNavigationService.forceNavigateToWorklist();
                    }
                  });
                }).catch();
              }
            });
          }
        }
      });

    }
  }

  public secondOpinionVisible(): any {
    return !this.testConfiguration.hide2ndOpinion;
  }

  public askSecondOpinion(practitioner: any) {
    if (!practitioner) {
      return;
    } else if (practitioner.id === this.pathologistInfoId) {
      // 2nd opinion from yourself is not allowed
      this.modalLoader.popupModal(ConfirmModalComponent,
        {
          title: '2<sup>nd</sup> Opinion error',
          content: 'Second opinion cannot be the same as the assignee.',
          approveBtn: 'OK'
        }, ModalTypes.ALERT).subscribe();
      return;
    }
    this.modalLoader.popupModal(ConfirmModalComponent,
      {
        title: `2<sup>nd</sup> Opinion process`,
        content: `Are you sure you want to send 2<sup>nd</sup> &nbsp;opinion request to ${practitioner.name[0].prefix[0]}. ${practitioner.name[0].given[0]} ${practitioner.name[0].family[0]}?`,
        approveBtn: 'OK',
        declineBtn: 'Cancel'
      }).subscribe(response => {
        if (response && response.payload && response.payload === 1) {
          this.workflowService.performWorkflowStep(this.currentPatientAnalysis, '2nd opinion requested', practitioner.id, this.currentRevision.id).then(() => {
            this.modalLoader.popupModal(ConfirmModalComponent,
              {
                title: `2<sup>nd</sup> Opinion request successfully sent`,
                content: `Your request for 2<sup>nd</sup> &nbsp;opinion was sent`,
                approveBtn: 'OK',
                declineBtn: 'Cancel'
              }).subscribe(response1 => {
                if (response1) {
                  this.testService.activeTab = activeTabObject.GENOMIC_ABERRATIONS;
                    this.setDefaultAnnotations();
                  this.routerManagerService.reload();
                }
              });
          });
        }
      });

  }

  public getReleaseReportTitle(): any {
    return this.translateService.instant(this.DEFAULT_RELEASE_REPORT_TITLE) ||  this.DEFAULT_RELEASE_REPORT_TITLE;
  }

  public releaseReport() {
    if (!this.releaseInitialReportDialogIsOpen) {
      this.releaseInitialReportDialogIsOpen = true;
      this.modalLoader.popupModal(ConfirmModalComponent,
        {
          title: this.getReleaseReportTitle(),
          content: 'Are you sure you want to release a report? ',
          approveBtn: 'OK',
          declineBtn: 'Cancel'
        }, ModalTypes.ALERT).subscribe(response => {
        if (response && response.payload) {
          this.releaseInitialReportDialogIsOpen = false;
          if (response.payload === 1) {
            this.currentPatientAnalysis.opinions = this.getCurrentPerformerOpinion();
            this.currentPatientAnalysis.localDateTime = this.testService.getLocalDateTime();
            this.currentPatientAnalysis.localTime = this.testService.getLocalTime();
            this.currentPatientAnalysis.clientTimeZone = new Date().getTimezoneOffset();

            this.currentPatientAnalysis.user = this.authService.user;
            const workflowRequestId = this.currentPatientAnalysis.workflowRequest && this.currentPatientAnalysis.workflowRequest.id;
            this.workflowService.performWorkflowStep(this.currentPatientAnalysis, this.getReleaseReportStep(), '',
              this.currentRevision.id, workflowRequestId).then((res) => {

              let dialogMessage = 'Report released successfully';
              if (res.data.message === 'missing Required Information') {
                dialogMessage = 'Required information for test info is missing';
              } else {
                if (this.getMoveToApproved()) {
                  this.saveState('approved');
                  this.testService.activeTab = activeTabObject.GENOMIC_ABERRATIONS;
                } else {
                  this.testService.activeTab = activeTabObject.GENOMIC_ABERRATIONS;
                }
              }

              this.modalLoader.popupModal(ConfirmModalComponent,
                {
                  content: dialogMessage,
                  approveBtn: 'OK'
                }, ModalTypes.ALERT).subscribe(response1 => {
                if (response1) {
                  this.getMoveToApproved();
                  this.routerManagerService.reload();
                }
              });
            })
            .catch(() => {
              this.notificationMessageService.error('unable to release report');
            });
          }
        }
      });

    }
  }

  public getReleaseReportStep(): any {
    return _.get(this.testConfiguration, 'releaseReportButton.workflowStep', (this.translateService.instant(this.DEFAULT_INITIAL_REPORT) || this.DEFAULT_INITIAL_REPORT));
  }

  public cancelSecondOpinion() {
    this.modalLoader.popupModal(ConfirmModalComponent,
      {
        title: '2<sup>nd</sup> Opinion cancel',
        content: 'Are you sure you want to cancel 2<sup>nd</sup> opinion request? ',
        approveBtn: 'OK',
        declineBtn: 'Cancel'
      }, ModalTypes.NONE).subscribe(response => {
      if (response && response.payload && response.payload === 1) {
        this.workflowService.performWorkflowStep(this.currentPatientAnalysis, 'review', this.pathologistInfoId, this.currentRevision.id).then((res) => {
          if (res.body.message === 'no second opinion') {
            this.modalLoader.popupModal(ConfirmModalComponent,
              {
                content: '2nd opinion results are already available',
                approveBtn: 'OK'
              }, ModalTypes.NONE).subscribe();

          } else {
            this.modalLoader.popupModal(ConfirmModalComponent,
              {
                title: '2<sup>nd</sup> Opinion was cancelled successfully',
                content: 'Your request for 2nd opinion was canceled',
                approveBtn: 'OK'
              }, ModalTypes.NONE).subscribe(response => {
              if (response) {
                this.testService.activeTab = activeTabObject.GENOMIC_ABERRATIONS;
                  this.setDefaultAnnotations();
                this.routerManagerService.reload();
              }
            });

          }
        }).catch(() => {
          this.notificationMessageService.error('unable to cancel 2nd opinion request');
        });
      }
    });

  }

  public releaseForInterpretation() {
    let modalPayload = {
      isAnyAberrationSelected: this.aberrationsCtrl.isAnyAberrationSelected
    }
    this.modalLoader.popupModal(
      PlaceholderModalComponent,
      {
        title: 'Release for interpretation',
        componentToLoad: ReleaseInterpretationComponent,
        buttons: {
          approveBtn: 'OK',
          declineBtn: 'Cancel'
        },
        payload: {
          modalPayload
        },
        approveCallback: () => {
          const providers = this.getInterpretationProviders();

          this.workflowService.performWorkflowStep(
            this.currentPatientAnalysis,
            'interpretation',
            '',
            this.currentRevision.id,
            undefined,
            undefined,
            undefined,
            { providers},
            false
          )
            .then(
              (res) => {
                if (res.status === 200) { // set flag for hide button "Release for interpretation"
                  this.testService.activeTab = activeTabObject.GENOMIC_ABERRATIONS;

                  const proceedData = JSON.parse(localStorage.getItem('test-proceed')) || [];

                  if (!proceedData.includes(this.currentRevision.id)) {
                    proceedData.push(this.currentRevision.id);
                    localStorage.setItem('test-proceed', JSON.stringify(proceedData));
                  }

                  return this.workflowConfigService.getCurrentActiveWorkflow().toPromise()
                    .then((activeWorkflow: IWorkflow) => this.pollJobService.waitForWorkflowCondition(this.routerManagerService.parameters.testId, this.currentRevision.id,
                      workflow => workflow.activeJobName !== activeWorkflow.activeJobName, 2000, 20)
                    )
                    .then(workflow => {
                      if (workflow.activeJobName.toLowerCase().includes('fail')) {
                        throw new Error('Can\'t perform workflow step');
                      }
                      this.setDefaultAnnotations();
                      this.routerManagerService.reload();
                    });
                }
              },
              () => {
                this.notificationMessageService.error('Unable to release for interpretation');
              }
            );
          return Observable.of(true);
        },
      },
      ModalTypes.NONE
    ).subscribe();
  }

  public isProceedAberrationEnable(): any {
    return this.currentRevision.status.toLowerCase() === 'initial results' && !this.isTestFailed;
  }

  public isProceedAberrationButtonDisabled(): any {
    const proceedData = JSON.parse(localStorage.getItem('test-proceed')) || [];
    return proceedData.includes(this.currentRevision.id);
  }

  public canReassignByRole(): any {
    return this.currentPatientAnalysis.performer === this.getUserId() ||
      this.currentPatientAnalysis.performer.toLowerCase() === 'none';
  }

  public reassignByRole() {
    const analysis = {
      activeRevision: this.stateParams.revisionId,
      workflowrequest_id: this.stateParams.testId,
      reassignFinished: false
    };

    const modalPayload: any = { };
    modalPayload.name = this.patient.name[0].text;
    modalPayload.testNumber = this.workflowService.currentTest.identifiers[0].value;
    modalPayload.analysis = analysis;
    modalPayload.practitionerRoles = ['Pathologist', 'Fellow'];
    modalPayload.enableReassign = !!(modalPayload.practitionerRoles.find(role => role.toLocaleLowerCase() === this.authService.getUser().role.toLocaleLowerCase()))
    modalPayload.practitionerFilterBy = modalPayload.analysis.practitionerFilterBy;
    modalPayload.disallowedPractitionerRoles = null;
    modalPayload.modalName = 'ReassignTestByRole';
    modalPayload.title = modalPayload.name + ', Test No. ' + modalPayload.testNumber;

    this.modalLoader.popupModal(
      ReassignTestModalComponent,
      {
        content: modalPayload,
        backdropAllowed: false
      },
      ModalTypes.NONE
    ).subscribe((data) => {
      if (data && data.payload && data.payload.action === 'close') {
        this.workflowService.getPatientAnalyses({
          'patientId': this.routerManagerService.parameters.patientId,
          'testId': this.stateParams.testId,
          'revisionId': this.stateParams.revisionId
        }, true).then((res) => {
          this.currentPatientAnalysis = res.body.current;
          this.workflowService.performWorkflowStep(this.currentPatientAnalysis, 'final review', null,
            this.stateParams.revisionId, this.stateParams.testId, null, null)
            .then(() => {
              this.routerManagerService.reload();
            });
        })
      }
    });
  }

  public isShowLoader(): boolean {
    const filter = this.aberrationsCtrl.filter.toLowerCase();
    return this.dataIsLoading && (filter === 'all' || filter === 'selected');
  }

  public isSortableColumn(col: any): any {
    return this.highlighted.length > 1 && col.sortable;
  }

  public onSortColumn(col: any) {
    const tableSortBy = this.currentTableSortBy();
    this.getFilterByTypeAndSubType(this.ABERRATION_OBJECT_NAME, this.currentModality)
      .take(1)
      .subscribe(filters => {
        const colName = col.columnName;
        if (tableSortBy.column === colName) {
          tableSortBy.dir = !tableSortBy.dir;
        } else {
          tableSortBy.column = colName;
          tableSortBy.dir = true;
          tableSortBy.sortAsExpression = col.sortAsExpression;
        }
        this.dataIsLoading = true;
        this.isSorting = true;

        if (this.aberrationsCtrl.filter === 'selected') {
          this.aberrationsCtrl.filter = '';
          this.getSelectedAberrations();
        } else {
          this.loadIdsList(filters, this.testTypeId, this.currentModality, tableSortBy);
        }
      });
  }

  public isSortUp(col: any): any {
    const tableSortBy = this.currentTableSortBy();
    return tableSortBy.column === col.columnName && tableSortBy.dir;
  }

  public isSortMiddle(col: any): any {
    const tableSortBy = this.currentTableSortBy();
    return tableSortBy.column !== col.columnName;
  }

  public isFiltered(aberration: any): any {
    let opinions = [];

    for (let i = 0; i < this.aberrationsCtrl.opinions.length; i++) {
      if (this.aberrationsCtrl.secondOpinionsVisible || typeof this.aberrationsCtrl.secondOpinionsVisible === 'undefined') {
        opinions.push(this.aberrationsCtrl.opinions[i]);
      } else {
        opinions = [this.aberrationsCtrl.currentOpinion];
      }
    }

    if (this.aberrationsCtrl.filter === 'all') {
      return aberration;
    } else if (this.aberrationsCtrl.filter === 'selected') {
      return _.some(opinions, (opinion) => {
        return opinion.selections[aberration.id] === true;
      });
    }

    return;
  }

  public openAberrationDetails(aberration: any, igvOnly = false) {
    if (!this.testTableData.aberrationExtraDetails && !igvOnly) {
      return;
    }

    if (this.currentModality === this.modalitiesNames.wildtype){ //Annotation pop-up should not be available for 'wildtype'
      return;
    }

    const modalPayload = {
      currentAberration: cloneDeep(aberration),
      testTypeId: this.testTypeId,
      testTableData: cloneDeep(this.testTableData),
      currentModality: this.testService.modalitiesData['currentModality'],
      currentOpinion: this.aberrationsCtrl.currentOpinion,
      revisionId: this.resourcesMap.requestedRevision,
      firstRevisionId: this.resourcesMap.Aberration || this.resourcesMap.firstRevision,
      filterSelected: this.aberrationsCtrl.filter === 'selected',
      igvOnly: igvOnly,
      currentSort: this.currentTableSortBy(),
    };

    this.modalLoader.popupModal(PlaceholderModalComponent,
      {
        componentToLoad: AberrationExtraModalComponent,
        additionalStyles: {
          heightAdjust: true,
          paddingZero: true
        },
        payload: {
          modalPayload,
          hideHeader: true,
        },
        approveCallback: (modal: any) => {
          if (modal) {
            if (modal.isNoteChanged) {
              const index = _.findIndex(this.highlighted, (abr: any) => abr.id === modal.currentAberration.id);
              this.highlighted[index] = modal.currentAberration;
            } else if (modal.isSelectionChanged) {
              const opinionIndex = _.findIndex(this.aberrationsCtrl.opinions, (opinion: any) => opinion.id === this.aberrationsCtrl.currentOpinion.id);
              this.aberrationsCtrl.opinions[opinionIndex].selections[modal.currentAberration.id] = modal.selectionState;
              this.select(undefined, modal.currentAberration, this.aberrationsCtrl.opinions[opinionIndex]);
              this.cdr.markForCheck();
            }
          }
          return Observable.of(true);
        }
      }, ModalTypes.NONE)
      .subscribe(() => {
      });

  }

  public select($event: any, aberration: any, opinion: any) {
    const requestModality = this.testService.modalitiesData['currentModality'];
    this.aberrationsCtrl.currentOpinion.selections[aberration.id] = opinion.selections[aberration.id];

    const molecularFinding = this.molecularFindingToUpdate(aberration, opinion.selections[aberration.id]) ? this.testService.modalitiesData['modalitiesMap'][this.modalitiesNames.wildtype].results.molecularFindingResource : null;
    this.aberrationsCtrl.updateOpinionOperations += 1;

    this.aberrationsServiceNg2.saveBulkSelectionDelayed(aberration.id, opinion.id, opinion.selections[aberration.id], this.currentRevision.id, molecularFinding)
      .subscribe(
        () => {
          this.updateSelectedResultsList(aberration, requestModality, opinion.selections[aberration.id]);
          this.setSelectedAberrationsNumber(requestModality);
        },
        () => {
          opinion.selections[aberration.id] = !opinion.selections[aberration.id];
          this.aberrationsCtrl.currentOpinion.selections[aberration.id] = opinion.selections[aberration.id];
          if (molecularFinding != null) {
            this.updateWildTypesLocaly(aberration[this.getCurrentModalityGenePropertyName()], opinion.selections[aberration.id]);
          }
          this.setSelectedAberrationsNumber(requestModality);
        },
        () => {
          this.aberrationsCtrl.updateOpinionOperations -= 1;
        }
      );
    if ($event) {
      $event.stopPropagation();
    }
  }

  public molecularFindingToUpdate(aberration: any, toSelect: any) {
    let shouldUpdateMolecularFinding = this.wtCalculationMethod('Selection based') && !this.isSecondOpinion &&
      (this.testService.modalitiesData['currentModality'] === this.modalitiesNames.snv ||
        this.testService.modalitiesData['currentModality'] === this.modalitiesNames.cnv) &&
      !this.isGeneAnywaySelected(aberration);
    if (shouldUpdateMolecularFinding) {
      shouldUpdateMolecularFinding = this.updateMolecularFindingLocaly(aberration[this.getCurrentModalityGenePropertyName()], toSelect);
      if (shouldUpdateMolecularFinding) {
        this.updateWildTypesLocaly(aberration[this.getCurrentModalityGenePropertyName()], toSelect);
      }
    }
    return shouldUpdateMolecularFinding;
  }

  public isGeneAnywaySelected(selectedAberration: any) {
    let isGeneCurrentlySelected = false;
    for (const modality in this.testService.modalitiesData['modalitiesMap']) {
      const genePropertyName = this.getCurrentModalityGenePropertyName();
      if (this.testService.modalitiesData['modalitiesMap'][modality].selectedResults.selectedAberrations.filter(ab => selectedAberration.id !== ab.id && ab[genePropertyName] === selectedAberration[genePropertyName]).length > 0) {
        isGeneCurrentlySelected = true;
      }
    }
    return isGeneCurrentlySelected;
  }

  public updateSelectedResultsList(selectedAberration: any, requestModality: any, select: any) {
    const selectedAberrationIndex = _.findIndex(this.testService.modalitiesData['modalitiesMap'][requestModality].selectedResults.selectedAberrations,
      (aberration: any) => aberration.id === selectedAberration.id);
    const secondOpinionAberrationIndex = _.findIndex(this.aberrationsCtrl.opinions, (opinion: any) => {
      if (opinion.order === 2) {
        return selectedAberration.id in opinion.selections;
      }
    });

    if (selectedAberrationIndex === -1 && select) {
      this.testService.modalitiesData['modalitiesMap'][requestModality].selectedResults.selectedAberrations.push(cloneDeep(selectedAberration));
    } else if (selectedAberrationIndex !== -1 && !select && secondOpinionAberrationIndex === -1) {
      this.testService.modalitiesData['modalitiesMap'][requestModality].selectedResults.selectedAberrations.splice(selectedAberrationIndex, 1);
    }
  }

  public updateWildTypesLocaly(geneName: any, select: any) {
    const wildtypes = this.testService.modalitiesData['modalitiesMap'][this.modalitiesNames.wildtype].results.aberrations;
    const wtIndex = _.findIndex(wildtypes, (wt: any) => wt.gene === geneName);
    if (wtIndex !== -1) {
      this.updateSpecificWildTypeLocaly(wildtypes[wtIndex], select);
    }
  }

  public getCurrentModalityGenePropertyName(): any {
    return this.getGenePropertyName(this.testService.modalitiesData['currentModality']);
  }

  public getTooltip(tooltipName: string): string {
    return this.translateService.instant('aberration.tooltip.' + tooltipName) || '';
  }

  public isTooltipEnabled(col: any): boolean {
    return !col.tooltipHidden;
  }

  public updateNote(newNote: any, aberration: any) {
    aberration.hasNotes = newNote.hasNotes;
    aberration.lastNoteText = newNote.text;
  }

  public getAberrationInfo(aberration: any) {
    this.collapsed[aberration.id] = !this.collapsed[aberration.id];
    if (aberration.links) {
      return;
    }

    this.loadModalityContent = false;
    try {
      const aberrationsPromises = [];
      aberrationsPromises.push(this.aberrationInfoService.getAberrationInfoPromise(aberration, this.testTableData, this.currentRevision.id, this.testService.modalitiesData['currentModality']));

      let searchLinksConfigIds = this.testService.getCurrentDynamicSearchableLinksConfig();
      if (searchLinksConfigIds === null) {
        searchLinksConfigIds = ['defaultLinks'];
      }
      aberrationsPromises.push(this.aberrationsServiceNg2.getSearchLinksConfiguration(searchLinksConfigIds).toPromise());

      Promise.all(aberrationsPromises)
        .then((results) => {
          aberration.extra = results[0];
          this.cdr.markForCheck();
          const searchLinkConfig = results[1];

          _.each(searchLinkConfig, (searchLinkConfig) => {
            if (typeof searchLinkConfig.searchModalities[this.currentModality] !== 'undefined') {
              this.aberrationsServiceNg2.generateModalitySearchLink(searchLinkConfig.searchModalities[this.currentModality], {
                aberration: aberration,
                cacheKey: this.workflowConfigService.getCacheKeySync()
              })
                .take(1)
                .subscribe(link => {
                  this.buildSearchableLinks(aberration, link, searchLinkConfig);
                  this.loadModalityContent = true;
                });
            } else {
              this.loadModalityContent = true;
            }
          });

        })
        .catch(() => {
          this.collapsed[aberration.id] = true;
          this.loadModalityContent = true;
        });
    } catch (err) {
      this.collapsed[aberration.id] = true;
      this.loadModalityContent = true;
    }
  }

  public buildSearchableLinks(aberration: any, generatedLink: any, linkConfig: any) {
    if (typeof aberration['links'] === 'undefined') {
      aberration.links = [];
    }
    aberration.links.push({
      href: generatedLink,
      config: linkConfig.searchModalities[this.currentModality],
      classes: linkConfig.classes
    });
  }

  public shouldDisplayCategory(annotationCategory: any): boolean {
    if (typeof this.testTableData.displayAnnotations !== 'undefined') {
      return typeof this.testTableData.displayAnnotations[annotationCategory] !== 'undefined';
    }

    return true;
  }

  public annotParams(annExtraData: any): any {
    const params = [
      {
        'name': annExtraData.name,
        'value': annExtraData.value
      }
    ];

    if (annExtraData.stable_cosmic_id) {
      params.push({
        'name': 'stable_cosmic_id',
        'value': annExtraData.stable_cosmic_id
      });
    }

    return params;
  }

  public shouldDisplayAnnotation(annotationCategory: any, annotation: any): any {
    if (typeof this.testTableData.displayAnnotations !== 'undefined') {
      if (typeof this.testTableData.displayAnnotations[annotationCategory] !== 'undefined') {
        const categoryData = this.testTableData.displayAnnotations[annotationCategory];
        return annotation.annotationSource ?
          this.checkAnnotationInConfig(categoryData, annotation) && this.checkAnnotationSourceInConfig(categoryData, annotation.annotationSource)
          : this.checkAnnotationInConfig(categoryData, annotation);
      }
      return false;
    }
    return true;
  }

  public checkAnnotationInConfig(categoryData: any, annotation: any): any {
    if (categoryData.allowedAnnotations) {
      const isAllowedAnnotationsAll = categoryData.allowedAnnotations.length > 0 &&
        categoryData.allowedAnnotations[0] === 'ALL';
      if (isAllowedAnnotationsAll) { return true; }
      return categoryData.allowedAnnotations.some(allowedAnn => {
        return allowedAnn === annotation.name;
      });
    } else { // support old format
      if (Array.isArray(categoryData)) {
        return categoryData.indexOf(annotation.name) !== -1;
      }
    }
  }

  public checkAnnotationSourceInConfig(categoryData: any, annotationSource: any): any {
    if (categoryData.allowedSources) {
      const isAllowedSourcesAll = categoryData.allowedSources.length > 0 &&
        categoryData.allowedSources[0] === 'ALL';
      if (isAllowedSourcesAll) { return true; }
      return categoryData.allowedSources.some(source => {
        return source === annotationSource;
      });
    }
    return true;
  }

  public isUrl(value: any): any {
    const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@\-\/]))?/;
    return regexp.test(value);
  }

  public cosmOrCosn(cosmicId: any): any {
    return cosmicId.contains('COSF') || cosmicId.contains('COSM');
  }

  public isEditAberrationEnable() {
    let editAberrationEnable = !!this.aberrationsCtrl.currentOpinion && this.aberrationsCtrl.currentOpinion.state === 'confirmed';
    if (editAberrationEnable) {
      const userId = this.getUserId();
      editAberrationEnable = this.currentPatientAnalysis.performer === userId;
    }
    return editAberrationEnable;
  }

  public getOpinionState(opinion: any): any {
    if (this.canPerformTestActions()) {
      return opinion.state;
    }
    return null;
  }

  public cosmicURL(cosmicId: any): any {
    if (cosmicId.contains('COSF')) {
      return 'https://grch37-cancer.sanger.ac.uk/cosmic/fusion/summary?id=' + cosmicId.replace(/^COSF/, '');
    } else {
      if (cosmicId.contains('COSM')) {
        return 'https://grch37-cancer.sanger.ac.uk/cosmic/mutation/overview?id=' + cosmicId.replace(/^COSM/, '');
      }
    }
  }

  public clearAllAppliedFilters() {
    this.filterService.clearAppliedFilters();
  }

  public getFilterPanelstate(): boolean {
    return this.testService.isFilterPanelClose;
  }

  public getKeys(dataObject: any): any {
    if (dataObject) {
      return Object.keys(dataObject);
    }
  }

  public getTooltipText(data: string): string {
    return 'annotation.' + data;
  }

  public getAnnotation(value: string): string {
    return this.translateService.instant('annotation.' + value);
  }

  public annData(index: number, ann) {
    return ann.name;
  }

  public annParamData(index: number, annParam) {
    return annParam.name;
  }

  public rowData(index: number, data) {
    return data.id;
  }

  public setDefaultAnnotations() {
    if (this.testService.testConfiguration && this.testService.testConfiguration.requiredAnnotations) {
      this.selectModality(this.testService.testConfiguration.requiredAnnotations[0]);
    }
  }

  public ngOnDestroy() {
    if (this.loaderSubscriber) {
      this.loaderSubscriber.unsubscribe();
    }

    if (this.appliedFilterPropertiesSubscriber) {
      this.appliedFilterPropertiesSubscriber.unsubscribe();
    }

    this.subscribers.forEach(subscriber => subscriber.unsubscribe());
    window.removeEventListener('scroll', this.onScroll, true);
  }
}
